import React from 'react';
import PropTypes from 'prop-types';

class SearchField extends React.Component {
    handleOnSubmit = (event) => {
        const {
            handleSearch,
        } = this.props;

        event.preventDefault();
        this.textInput.blur();

        handleSearch();
    }

    render() {
        const {
            query,
            handleUpdateQuery,
            buttonLabel,
        } = this.props;

        return (
            <React.Fragment>
                <form className="input-group" role="search" onSubmit={(event) => { this.handleOnSubmit(event); }}>
                    <input
                        className="form-input"
                        type="text"
                        value={query}
                        onChange={(event) => { handleUpdateQuery(event.target.value); }} // eslint-disable-line max-len
                        ref={(input) => { this.textInput = input; }}
                    />
                    <input type="submit" value={buttonLabel} className="button is-large" />
                </form>
            </React.Fragment>
        );
    }
}

SearchField.propTypes = {
    query: PropTypes.string.isRequired,
    handleUpdateQuery: PropTypes.func.isRequired,
    handleSearch: PropTypes.func.isRequired,
    buttonLabel: PropTypes.string.isRequired,
};

export default SearchField;
